/**
 * make the value to be always a positive and subtract ts from the relative value
 */
const getOffset = (ts, relative) => Math.abs(relative - ts);
/**
 * get the closet value by comparing the new value from the exiting value
 */


const getClosest = (relative, newValue, existingValue) => {
  if (!existingValue) {
    return newValue;
  }

  const aOffset = getOffset(newValue.ts, relative);
  const bOffset = getOffset(existingValue.ts, relative);
  return aOffset < bOffset ? newValue : existingValue;
};

const getWindow = (relative, windowSize) => [relative - windowSize, relative + windowSize];

/**
 * Create a function that will return whether or not a given timeframe is within the provided window
 *
 * @param relative midpoint of the window, times compared relative to this point
 * @param windowSize if provided as zero will return true for times that are equal to `relative`
 */
const createWindowCheck = (relative, windowSize) => {
  const [start, end] = getWindow(relative, windowSize);
  return ts => start <= ts && end >= ts;
};
/**
 * Get one of each vital closes to the given relative time withing the appropriate window size
 */


export const getClosestVitals = function (relative, vitals) {
  let window = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const isInWindow = createWindowCheck(relative, window);
  const closeVital = vitals.reduce((prev, curr) => {
    const inWindow = isInWindow(curr.ts);

    if (!inWindow) {
      return prev;
    }

    const type = curr.type;
    return { ...prev,
      [type]: getClosest(relative, curr, prev[type])
    };
  }, {});
  return closeVital;
};

const getBaseMeasures = (base, input) => input.filter(metric => metric.type === base);

const resolveMeasures = (config, input, params) => {
  const baseMeasures = getBaseMeasures(config.base, input);
  return baseMeasures.map(relative => {
    const closestVitals = getClosestVitals(relative.ts, input, config.window);
    return config.resolve(relative.ts, closestVitals, params);
  }).flat();
};
/**
 * allows us to create a calculator from a set of interpreter configurations so that the user does not manually need to traverse a collection of configs
 */


export const interpret = configs => (input, params) => configs.map(config => resolveMeasures(config, input, params)).flat();
/**
 * compose allows us to merge multiple calculators into a single calculator that we can apply without the need for many function calls. this enables separation of calculators which makes them easier to manage, define, and test
 */

export const compose = resolvers => (input, params) => resolvers.map(calculate => calculate(input, params)).flat();
//# sourceMappingURL=interpreter.js.map